import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';
import Select, { components } from 'react-select';
import withStyles from 'react-jss';
import { Translation } from 'react-i18next';
import { getPreRegistrationState, getTenantState } from '../../store/selectors';
import { addLocation } from '../../store/actions';
import ProgressBar from '../utility/ProgressBar';
import LoginButton from '../utility/LoginButton';
import NextButton from '../utility/NextButton';
import PoweredByASUBlackAndWhite from '../utility/PoweredByASUBlackAndWhite';
import RouteBack from '../utility/RouteBack';
import SchoolLogo from '../utility/SchoolLogo';
import { location } from '../../copy/onboardingCopy.json';
import countriesList from '../../util/countriesList.json';
import countryTerritories from '../../util/countryTerritories.json';
import { fireGTM } from '../../gtm/gtmUtil';
import { locationPage_GTM } from '../../gtm/datalayers/locationDataLayers.json';
import WindowTitle from '../utility/WindowTitle';
import i18next from 'i18next';

const bars = {
  Onboarding: {
    current: 0,
    override: true,
  },
  'Picture Game': {
    current: 0,
    override: false,
  },
  'Career Path': {
    current: 0,
    override: false,
  },
};

const nextButtonStyles = {
  color: (props) => ({
    backgroundColor: props.tenant.primary,
    borderColor: props.tenant.primary,

    '&:hover': {
      backgroundColor: 'white',
      border: `2px solid ${props.tenant.primary}`,
      color: props.tenant.primary,
      borderStyle: 'solid',
    },
  }),
};

class Location extends Component {
  constructor(props) {
    super(props);
    this.state = {
      percent: 35,
      locationSelected: false,
      showTerritorySelect: false,
      listOfCountries: [],
      listOfTerritories: [],
      userCountry: null,
      userTerritory: null,
      currentLocale: i18next.language,
    };
    this.showValidLocationData = this.showValidLocationData.bind(this);
    this.handleCountrySelected = this.handleCountrySelected.bind(this);
    this.handleTerritorySelected = this.handleTerritorySelected.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  dropDown = {
    color: this.props.tenant.primary,
  };

  secondaryBorderLarge = {
    borderTop: `11px solid ${this.props.tenant.secondary}`,
  };

  secondaryBorder = {
    borderBottom: `5px solid ${this.props.tenant.secondary}`,
  };

  componentDidMount() {
    const { preregistration } = this.props;

    this.showValidLocationData();
    this.getTerritories();

    if (preregistration.country) {
      if (
        preregistration.country === 'United States' &&
        !preregistration.territory
      ) {
        this.setState({
          userCountry: preregistration.country,
          showTerritorySelect: true,
          locationSelected: false,
        });
      } else if (preregistration.territory) {
        this.setState({
          userCountry: preregistration.country,
          userTerritory: preregistration.territory,
          showTerritorySelect: true,
          locationSelected: true,
        });
      } else {
        this.setState({
          userCountry: preregistration.country,
          locationSelected: true,
        });
      }
    }
  }

  // Temp helper while b/e APIs are built --> we know we only need the values of the states obj

  getTerritoriesPerCountry = (countryTerritories) => {
    const territoryList = Object.values(countryTerritories);

    territoryList.sort();

    return territoryList.map((territory) => {
      return { value: territory, label: territory };
    });
  };
  getTerritories() {
    const territoryOptions = this.getTerritoriesPerCountry(countryTerritories);
    this.setState({ listOfTerritories: territoryOptions });
  }

  CustomInput = (props) => {
    /* eslint-disable react/jsx-props-no-spreading */
    return (
      <components.Input
        {...props}
        role="combobox"
        aria-controls={`${props.id}-combobox-menu-list`}
        aria-expanded={props.selectProps.menuIsOpen}
        aria-activedescendant=""
      />
    );
    /* eslint-enable react/jsx-props-no-spreading */
  };

  CustomMenuList = (props) => {
    /* eslint-disable react/jsx-props-no-spreading */
    return (
      <components.MenuList {...props}>
        <div
          role="listbox"
          id={`${props.selectProps.inputId}-combobox-menu-list`}
        >
          {props.children}
        </div>
      </components.MenuList>
    );
    /* eslint-enable react/jsx-props-no-spreading */
  };

  CustomOption = (props) => {
    /* eslint-disable react/jsx-props-no-spreading */
    return (
      <components.Option {...props}>
        <div
          role="option"
          aria-selected={props.selectProps.value === props.children}
        >
          {props.children}
        </div>
      </components.Option>
    );
    /* eslint-enable react/jsx-props-no-spreading */
  };

  handleCountrySelected(country) {
    locationPage_GTM.country.text = country.value.toLowerCase();
    fireGTM(locationPage_GTM.country);

    let countryHasTerritories = false;
    if (countriesList[country.value]) {
      countryHasTerritories = !_.isEmpty(
        countriesList[country.value].territories
      );
    }

    if (countryHasTerritories) {
      this.getTerritories();
    }

    this.setState({
      userCountry: country.value,
      showTerritorySelect: countryHasTerritories,
      locationSelected: !countryHasTerritories,
      percent: 50,
    });

    this.props.addLocation({
      country: country.value,
    });
  }

  handleTerritorySelected(territory) {
    locationPage_GTM.state.text = territory.value.toLowerCase();
    fireGTM(locationPage_GTM.state);
    this.setState({
      userTerritory: territory.value,
      locationSelected: true,
    });

    if (this.state.userCountry) {
      this.props.addLocation({
        country: this.state.userCountry,
        territory: territory.value,
      });
    }
  }

  setCountriesList({
    countriesList,
    translatedUsaText,
    translatedOtherCountryText,
    usaText,
    otherCountryText,
  }) {
    let countriesToInclude = [];
    const currentLocale =
      this.state.currentLocale === 'fr' ? 'frText' : 'enText';
    Object.keys(countriesList).map((key) => {
      if (countriesList[key].excluded === 'False') {
        return countriesToInclude.push(key);
      }

      return key;
    });
    countriesToInclude.sort((a, b) => {
      return String(countriesList[a][currentLocale]).localeCompare(
        String(countriesList[b][currentLocale])
      );
    });
    countriesToInclude = countriesToInclude.map((country) => {
      return { value: country, label: countriesList[country][currentLocale] };
    });

    countriesToInclude.unshift({
      value: usaText,
      label: currentLocale === 'fr' ? translatedUsaText : usaText,
    });

    countriesToInclude.push({
      value: otherCountryText,
      label:
        currentLocale === 'fr' ? translatedOtherCountryText : otherCountryText,
    });

    return countriesToInclude;
  }

  showValidLocationData() {
    this.setState({
      listOfCountries: this.setCountriesList({
        countriesList,
        translatedUsaText: i18next.t(location.usaText),
        translatedOtherCountryText: i18next.t(location.otherCountryText),
        usaText: location.usaText,
        otherCountryText: location.otherCountryText,
      }),
    });
  }

  handleSubmit() {
    if (this.state.userTerritory) {
      this.props.addLocation({
        country: this.state.userCountry,
        territory: this.state.userTerritory,
      });
      locationPage_GTM.nextLocationButton.state =
        this.state.userTerritory.toLowerCase();
    } else {
      this.props.addLocation({
        country: this.state.userCountry,
      });
    }

    // Google Tag Manager
    locationPage_GTM.nextLocationButton.country =
      this.state.userCountry.toLowerCase();
    fireGTM(locationPage_GTM.nextLocationButton);
    this.props.history.push(
      `/${this.props.tenant.name.toLowerCase()}/terms-and-conditions`
    );
  }

  render() {
    const {
      userCountry,
      listOfCountries,
      userTerritory,
      listOfTerritories,
      showTerritorySelect,
    } = this.state;
    const { primary } = this.props.tenant;
    const territoryClass = showTerritorySelect
      ? 'territory'
      : 'hidden territory';
    const customStyles = {
      option: (provided) => ({
        ...provided,
        color: primary,
      }),
      input: (provided) => ({
        ...provided,
        color: primary,
      }),
      placeholder: (provided) => ({
        ...provided,
        color: primary,
      }),
      singleValue: (provided) => ({
        ...provided,
        color: primary,
        overflow: 'visible',
      }),
      dropdownIndicator: (provided) => ({
        ...provided,
        color: primary,
      }),
    };

    return (
      <Translation>
        {(t) => (
          <>
            <WindowTitle>
              {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
              {t('Onboarding')} - {t('Location')}
            </WindowTitle>
            {/* --------------- Top Section --------------- */}
            <div id="location-page" style={this.secondaryBorderLarge}>
              <div className="top-section">
                <div className="utility-container">
                  <RouteBack
                    color={this.props.tenant.primary}
                    route="/onboarding/education"
                    tenant={this.props.tenant}
                    section="tell us where you're currently located"
                    text="back"
                  />
                  <LoginButton
                    tenant={this.props.tenant}
                    color={this.props.tenant.primary}
                    isAuthenticated={this.props.auth.isAuthenticated}
                    section="tell us where you're currently located"
                  />
                </div>
                <div className="logo-text-container">
                  {/* TODO: Make this more dyanmic but for now we know what the size should be on this specific page */}
                  <SchoolLogo
                    schoolLogoWidth="90%"
                    horizontalAlign="flex-start"
                  />
                  <div className="header-text-container">
                    <h1>{t('What country are you currently located in?')}</h1>
                    <div className="fake-border" style={this.secondaryBorder} />
                  </div>
                  {/* Need this to center the header text */}
                  <div className="column is-one-quarter asu-logo-container-game-dummy" />
                </div>
              </div>
              {/* --------------- Middle Section --------------- */}
              {/* --- Country Drop Down --- */}
              <div className="columns is-centered is-multiline middle-section">
                <div className="dropdowns-container">
                  <Select
                    components={{
                      Input: this.CustomInput,
                      MenuList: this.CustomMenuList,
                      Option: this.CustomOption,
                    }}
                    onChange={this.handleCountrySelected}
                    options={listOfCountries}
                    className="dropdown-select"
                    inputId="country-select"
                    styles={customStyles}
                    placeholder={userCountry || t('Country')}
                    aria-label="type your country"
                  />
                  <div className={territoryClass}>
                    <Select
                      components={{
                        Input: this.CustomInput,
                        MenuList: this.CustomMenuList,
                        Option: this.CustomOption,
                      }}
                      onChange={this.handleTerritorySelected}
                      options={listOfTerritories}
                      className="dropdown-select"
                      inputId="state-select"
                      styles={customStyles}
                      placeholder={userTerritory || t('State')}
                      aria-label="type your state"
                    />
                  </div>
                </div>
                <NextButton
                  overRideStyle="location-next-button"
                  color={this.props.tenant.primary}
                  id="submit"
                  type="submit"
                  text="Next"
                  isActive={this.state.locationSelected}
                  onClick={() => this.handleSubmit()}
                  nextPath={`/${this.props.tenant.name.toLowerCase()}/terms-and-conditions`}
                />
              </div>
              {/* --------------- Bottom Section --------------- */}
              <div className="bottom-section">
                <ProgressBar
                  bars={bars}
                  currentPhase={this.state.percent}
                  tenant={this.props.tenant}
                />
              </div>
              <PoweredByASUBlackAndWhite tenant={this.props.tenant} />
            </div>
          </>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = (state) => {
  const tenant = getTenantState(state);
  const preregistration = getPreRegistrationState(state);
  const auth = state.auth;

  return { tenant, preregistration, auth };
};

const locationWithRouter = withRouter(
  connect(mapStateToProps, { addLocation })(Location)
);

export default withStyles(nextButtonStyles)(locationWithRouter);
